import {
  Avatar,
  Box,
  Chip,
  Container,
  Grid,
  Paper,
  Stack,
  Typography,
} from "@mui/material";
import React, { useState, useRef, useContext, useEffect } from "react";
import bg from "../../@shared/assets/mydecksbg.png";
import bg1 from "../../@shared/assets/dashboard_header.png";
import { useNavigate } from "react-router-dom";
import NeoButton from "../../components/NeoButton";
import JoinRoomModal from "../../components/JoinRoomModal";
import StartRoomModal from "../../components/StartRoomModal";
import { useAuthStore } from "../../@shared/store/useAuthStore";
import SpriteAnimator from "../../components/gamePlay/SpriteAnimator";
import PackOpeningModal from "../../components/PackOpeningModal";
import { formatNumber, getBadgeByLevel } from "../../@shared/utils/Utils";
import QuestsAndRewardsModal from "../../components/QuestsAndRewardsModal";
import LeaderBoardModal from "../../components/LeaderBoardModal";
import { MainContext } from "../../App";
import VoidCityScene from "../../components/mapScenes/voidCity/VoidCityScene";
import SettingsDrawer from "../../components/SettingsDrawer";
import WebJoystick from "../../components/WebJoystick";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import throttle from "lodash.throttle";
import {
  subscribeToPartyPresence,
  updatePlayerPresence,
} from "../../@shared/utils/roomFunctions";
import { getVoidCityNpcDialogue } from "../../@shared/utils/npcDialogs";
import NeoMenuItem from "../../components/NeoItem";
import { getQuestProgress } from "../../@shared/utils/Utils";
import {
  Add,
  AddRounded,
  ArrowForwardIos,
  Cancel,
  CheckCircle,
  MenuRounded,
  PlusOneRounded,
} from "@mui/icons-material";
import { starterQuests } from "../../@shared/game/starterQuests";
import MyQuestsModal from "../../components/MyQuestsModal";
import TownQuestsModal from "../../components/TownQuestsModal";
import { motion } from "framer-motion";
import Toast from "../../components/Toast";
import { useTutorial } from "../../@shared/utils/useTutorial";
import TutorialInfinityOrb from "../../components/TutorialInfinityOrb";
import {
  addDoc,
  collection,
  doc,
  getDocs,
  updateDoc,
} from "firebase/firestore";
import { db } from "../../@shared/firebase/config";

const PracticeWorld = () => {
  const { navigate, setMessage, setInfo } = useContext(MainContext);
  const { Theme } = React.useContext(MainContext);
  const theme = useTheme();

  // true if viewport width is 600px or less (MUI's `sm` breakpoint)
  const isXs = useMediaQuery(theme.breakpoints.down("sm"));

  //userData ====================================
  const { userData } = useAuthStore();
  const [rewards, setRewards] = useState(userData?.rewards || []);
  const [quests, setQuests] = useState(userData?.quests || []);
  const [questLog, setQuestLog] = useState(userData?.questLog || []);
  const [infinityTokens, setInfinityTokens] = useState(
    userData?.infinityTokens || "0"
  );
  const { progress, sequence, advanceStep } = useTutorial(userData.id);

  console.log("progress and sequence", progress, sequence);

  // derive card/deck counts (adjust these to match your actual data shape)
  const totalCards = userData.cards?.length || 0;
  const hasDeck = (userData.decks?.length || 0) > 0;

  const [settingsVisible, setSettingsVisible] = useState(false);

  const [startRoomVisible, setStartRoomVisible] = useState(false);
  const [joinRoomVisible, setJoinRoomVisible] = useState(false);
  const [questsAndRewardsVisible, setQuestsAndRewardsVisible] = useState(false);
  const [packOpeningVisible, setPackOpeningVisible] = useState(false);
  const [leaderboardVisible, setLeaderboardVisible] = useState(false);
  const [myQuestsVisible, setMyQuestsVisible] = useState(false);
  const [townQuestsVisible, setTownQuestsVisible] = useState(false);
  const [townQuests, setTownQuests] = useState(starterQuests);

  const [isCheckingMatch, setIsCheckingMatch] = useState(true);
  const [resumingMatch, setResumingMatch] = useState(false);
  const spriteRef = useRef(null);

  const [canInteract, setCanInteract] = useState(false);
  const [interactionTarget, setInteractionTarget] = useState(null); // could be 'door' or 'npc'

  const [players, setPlayers] = useState({});

  console.log("players", players);

  const unclaimedRewardsAndQuests = rewards?.filter(
    (r) => r.claimed === false
  ).length;

  useEffect(() => {
    if (!userData || !userData.partyId) {
      navigate("/");
    }
  }, [userData]);

  useEffect(() => {
    const original = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = original;
    };
  }, []);

  //   useEffect(() => {
  //     if (!partyId) {
  //       navigate("/");
  //     }
  //   }, [partyId]);

  // listen for our Phaser “door-proximity” events

  useEffect(() => {
    const handleDoor = (e) => {
      if (e.detail === true) setInteractionTarget("door");
      else setInteractionTarget(null);
    };

    const handleNpc = (e) => {
      if (e.detail) setInteractionTarget("npc");
      else setInteractionTarget(null);
    };

    window.addEventListener("interact-proximity", handleDoor);
    window.addEventListener("npc-proximity", handleNpc);

    return () => {
      window.removeEventListener("interact-proximity", handleDoor);
      window.removeEventListener("npc-proximity", handleNpc);
    };
  }, []);

  // when in firstDeck, and step 0 (collectRewards), check for 40+ cards
  useEffect(() => {
    if (
      progress?.currentSequence === "firstDeck" &&
      progress.currentStepIndex === 0 &&
      totalCards >= 40
    ) {
      advanceStep();
    }
  }, [progress, totalCards, advanceStep]);

  // when in firstDeck, and step 2 (buildDeck), check for deck creation
  useEffect(() => {
    if (
      progress?.currentSequence === "firstDeck" &&
      progress.currentStepIndex === 1 &&
      hasDeck
    ) {
      advanceStep();
    }
  }, [progress, hasDeck, advanceStep]);

  useEffect(() => {
    const unsubscribe = subscribeToPartyPresence(
      userData?.partyId,
      (type, uid, data) => {
        setPlayers((prev) => {
          const next = { ...prev };
          if (type === "added" || type === "changed") {
            next[uid] = data;
          } else if (type === "removed") {
            delete next[uid];
          }
          return next;
        });
      }
    );

    return () => unsubscribe();
  }, []);

  useEffect(() => {
    if (interactionTarget === "door") {
      setCanInteract(true);
    } else {
      setCanInteract(false);
    }
  }, [interactionTarget]);

  useEffect(() => {
    const getInitialPosition = () => {
      let x = 0;
      let y = 0;

      switch (userData.world) {
        case "Void City":
          x = 710;
          y = 530;
          break;

        default:
          break;
      }

      return { x, y };
    };

    updatePlayerPresence(userData, {
      partyId: userData?.partyId,
      host: userData?.isHost,
      inGameRoom: false,
      // initial position/orientation:
      x: getInitialPosition().x,
      y: getInitialPosition().y,
      direction: 0,
      animState: "idle",
      device: "desktop",
      inGameRoom: false,
      roomId: "",
      emote: "",
      building: "",
      level: userData.level,
      name: userData.username,
      avatar: userData?.avatar?.ws,
      online: true,
    });
  }, [userData?.partyId]);

  const throttledUpdate = useRef(
    throttle((x, y, direction, animState) => {
      const current = players?.[userData.id] || {};
      updatePlayerPresence(userData, {
        ...current, // keep existing props
        partyId: userData?.partyId,
        host: userData?.isHost,
        inGameRoom: false,
        x,
        y,
        direction,
        animState,
      });
    }, 100)
  ).current;

  if (!userData) {
    return null;
  }

  const finishTutorial = async () => {
    const userRef = doc(db, "users", userData.id);

    const rewardsRef = collection(db, "users", userData.id, "rewards");
    // Fetch available character cards
    const cardsSnap = await getDocs(collection(db, "Infinity cards"));
    const totemCard = cardsSnap.docs
      .map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }))
      .map((card) => ({
        ...card,
        type: "Infinity",
      }))
      .find((card) => card.id === "bnySrxduySbFQmSdyRHs");

    const reward = {
      type: "finite card",
      issuedAt: Date.now(),
      claimed: false,
      reward: totemCard,
      amount: 1,
      description: "Reward for completing the tutorial",
    };

    await addDoc(rewardsRef, reward);

    await updateDoc(userRef, { completedTutorial: true });
    //issue reward for completing tutorial
  };

  const handleJoyMove = (dx, dy) => {
    window.dispatchEvent(
      new CustomEvent("joystick-move", { detail: { dx, dy } })
    );
  };
  const handleJoyRelease = () => {
    window.dispatchEvent(new Event("joystick-release"));
  };

  return (
    <Grid
      container
      xs={12}
      sx={{
        // p: { xs: 0, md: 2 },
        height: "100%",
        width: "100%",
        backgroundImage: `url(${bg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        overflow: "hidden",
        position: "relative",
      }}
    >
      {progress?.currentSequence === "firstDeck" &&
        sequence?.type === "deckBuilder" && (
          <Box
            sx={{
              position: "absolute",
              left: { xs: "75%", md: sequence?.orbPosition.left }, // e.g. "10%"
              top: { xs: "60%", md: sequence?.orbPosition.top }, // e.g. "80%"
              display: "flex",
              alignItems: "flex-end",
              zIndex: 3000,
              pointerEvents: "none", // so map interactions still work
            }}
          >
            <Box
              sx={{
                transform: {
                  xs: `scaleX(-1) scale(1.5)`,
                  md: `scale(${sequence.orbPosition.scale})`,
                  zIndex: 3001,
                },
                top: { xs: "30px", md: 0 }, // e.g. "80%"
                right: { xs: "40%", md: 0 }, // e.g. "80%"
                position: "relative",
              }}
            >
              <TutorialInfinityOrb orbPosition={sequence.orbPosition} />
            </Box>

            {/* Speech bubble */}
            <Box
              sx={{
                ml: 1,
                mb: 1,
                width: 150,
                bgcolor: "rgba(255,255,255,0.95)",
                borderRadius: 1,
                p: 1,
                pointerEvents: "auto", // allow button clicks if you add any
                boxShadow: 1,
                position: "relative",
                left: { xs: "-92%", md: "25%" },
                top: 70,
              }}
            >
              <Typography variant="caption" sx={{ fontSize: 10 }}>
                {sequence?.steps[progress.currentStepIndex].text}
              </Typography>
            </Box>
          </Box>
        )}
      {progress?.currentSequence === "firstDeck" &&
        sequence?.type === "deckBuilder" &&
        progress.currentStepIndex === sequence.steps.length - 1 && (
          <Box
            sx={{
              position: "absolute",
              bottom: { xs: 50, md: 90 },
              right: { xs: 45, md: "80%" },
              zIndex: 3002,
              pointerEvents: "auto",
            }}
          >
            <NeoButton
              isIcon
              icon={<ArrowForwardIos />}
              color={Theme.palette.tirciary.main}
              onClick={finishTutorial}
            />
          </Box>
        )}

      <Toast onFinish={() => {}} timeTilClose={3000} />
      <SettingsDrawer
        open={settingsVisible}
        onClose={() => setSettingsVisible(false)}
        screen={"world"}
      />

      {/* STORE & DAILY QUESTS */}
      <Box
        style={{
          position: "absolute",
          left: "4%",
          top: "16.5%",
          paddingHorizontal: 6,
          zIndex: 2,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <motion.div
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          style={{
            cursor: "pointer",
            outline: "none",
            width: "60px",
            height: "60px",
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "flex-end",
            position: "relative",
            marginBottom: "20px",
          }}
          onClick={() => {
            console.log("STORE");
            setMessage("Coming Soon!");
            setInfo(true);
            //   handleNavigate("Test");
            // setLeaderboardVisible(true);
          }}
        >
          <img
            src={require("../../@shared/assets/icons/store_deal_icon.png")}
            style={{
              width: "100%",
              height: "100%",
              position: "absolute",
              objectFit: "contain",
              left: 0,
            }}
          />

          <Typography
            style={{
              fontSize: 7.5,
              fontWeight: 900,
              color: "white",
              textAlign: "center",
              alignSelf: "center",
              position: "absolute",
              right: 0,
              bottom: 6,
              zIndex: 3,
              width: "100%",
              color: "#000",
            }}
          >
            24:00:00
          </Typography>
        </motion.div>

        <motion.div
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          style={{
            cursor: "pointer",
            outline: "none",
            width: "60px",
            height: "60px",
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "flex-end",
            position: "relative",
            marginBottom: "20px",
          }}
          onClick={() => {
            console.log("STORE");
            setMessage("Coming Soon!");
            setInfo(true);
            //   handleNavigate("Test");
            // setLeaderboardVisible(true);
          }}
        >
          <img
            src={require("../../@shared/assets/icons/add_timed_quest_chest_icon.png")}
            style={{
              width: "100%",
              height: "100%",
              position: "absolute",
              objectFit: "contain",
              left: 0,
            }}
          />

          <AddRounded
            size={24}
            color="white"
            style={{
              color: "#fff",
              position: "absolute",
              left: 18,
              bottom: 15,
            }}
          />
        </motion.div>

        <motion.div
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          style={{
            cursor: "pointer",
            outline: "none",
            width: "60px",
            height: "60px",
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "flex-end",
            position: "relative",
            marginBottom: "20px",
          }}
          onClick={() => {
            console.log("STORE");
            setMessage("Coming Soon!");
            setInfo(true);
            //   handleNavigate("Test");
            // setLeaderboardVisible(true);
          }}
        >
          <img
            src={require("../../@shared/assets/icons/add_timed_quest_chest_icon.png")}
            style={{
              width: "100%",
              height: "100%",
              position: "absolute",
              objectFit: "contain",
              left: 0,
            }}
          />

          <AddRounded
            size={24}
            color="white"
            style={{
              color: "#fff",
              position: "absolute",
              left: 18,
              bottom: 15,
            }}
          />
        </motion.div>

        <motion.div
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          style={{
            cursor: "pointer",
            outline: "none",
            width: "60px",
            height: "60px",
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "flex-end",
            position: "relative",
            marginBottom: "20px",
          }}
          onClick={() => {
            console.log("STORE");
            setMessage("Coming Soon!");
            setInfo(true);
            //   handleNavigate("Test");
            // setLeaderboardVisible(true);
          }}
        >
          <img
            src={require("../../@shared/assets/icons/add_timed_quest_chest_icon.png")}
            style={{
              width: "100%",
              height: "100%",
              position: "absolute",
              objectFit: "contain",
              left: 0,
            }}
          />

          <AddRounded
            size={24}
            color="white"
            style={{
              color: "#fff",
              position: "absolute",
              left: 18,
              bottom: 15,
            }}
          />
        </motion.div>
      </Box>

      <Box
        sx={{
          position: "absolute",
          left: "calc(4% + 80px)",
          top: "10%",
          paddingHorizontal: "6px",
          zIndex: 2,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          height: "50px",
          height: { xs: "90px", md: "300px" },
          overflowY: "auto",
          scrollbarWidth: "none",
        }}
      >
        <Stack spacing={0.5}>
          <Typography style={{ fontWeight: "bold", color: "white" }}>
            Party ID: {userData?.partyId}
          </Typography>
          {Object.entries(players).map(([uid, player]) => (
            <Paper
              key={uid}
              sx={{
                display: "flex",
                flexDirection: "column",
                background: "#00000050",
                padding: 0.5,
              }}
            >
              <Typography
                variant="body2"
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                  color: "#fff",
                }}
              >
                <Box
                  style={{
                    position: "relative",
                    height: 36,
                    width: 36,
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <img
                    src={getBadgeByLevel(userData.level).badge}
                    alt="badge"
                    style={{
                      width: "100%",
                      height: "100%",
                      position: "absolute",
                      top: 0,
                      left: 0,
                      objectFit: "contain",
                      zIndex: 0,
                    }}
                  />
                  <Typography
                    variant="caption"
                    style={{
                      zIndex: 1,
                      position: "absolute",
                      top: "50%",
                      left: "50%",
                      transform: "translate(-50%, -50%)",
                      color: "#fff",
                    }}
                  >
                    {player.level}
                  </Typography>
                </Box>
                {player.name}
                <Chip
                  label={
                    player.online
                      ? player.building
                        ? `In ${player.building}`
                        : player.inGameRoom
                        ? "In Game Room"
                        : "Online"
                      : "Offline"
                  }
                  color={player.online ? "success" : "default"}
                  style={{ marginLeft: 5 }}
                  size="small"
                />
              </Typography>

              {/* <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
				<Chip
				  label={
					player.inGameRoom ? "In Game Room" : "Not in Game Room"
				  }
				  color={player.inGameRoom ? "primary" : "default"}
				  size="small"
				/>
				{player.building && (
				  <Chip label={`In ${player.building}`} size="small" />
				)}
			  </Box> */}
            </Paper>
          ))}
        </Stack>
      </Box>

      <Container
        // maxWidth="xl"
        maxWidth={false}
        disableGutters
        sx={{
          height: "100%",
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          p: { xs: 0 },
        }}
      >
        <Box
          sx={{
            position: "absolute",
            bottom: { xs: 110, md: 16 }, // or whatever padding you like
            right: 16,
            zIndex: 10,
            display: "inline-flex", // ← shrink-wrap width
            width: "fit-content",
          }}
        >
          <NeoButton
            isIcon={true}
            icon={
              <img
                alt="lightning_icon"
                src={require("../../@shared/assets/icons/lightning_icon.png")}
                style={{
                  width: 30,
                  height: 30,
                  opacity: interactionTarget !== null ? 1 : 0.4,
                  transition: "opacity 0.2s",
                }}
                disabled={interactionTarget === null}
                onClick={() => {
                  window.dispatchEvent(new Event("press-enter"));
                  setInteractionTarget(null);
                }}
              />
            }
            color={Theme.palette.secondary.main}
          />
          {/* <NeoButton
			isIcon={true}
			icon={
			  <img
				alt="lightning_icon"
				src={require("../../@shared/assets/icons/lightning_icon.png")}
				style={{
				  width: 30,
				  height: 30,
				  opacity: canInteract ? 1 : 0.4,
				  transition: "opacity 0.2s",
				}}
				disabled={!canInteract}
				onClick={() => {
				  // fire our Phaser listener
				  window.dispatchEvent(new Event("press-enter"));
				  setCanInteract(false);
				}}
			  />
			}
			color={Theme.palette.primary.main}
		  /> */}
        </Box>

        {/* Dashboard Info Container */}
        <Grid
          item
          container
          xs={12}
          sm={8}
          md={5}
          lg={5}
          sx={{
            ...styles.container,
            display: { xs: "flex" },
            flexDirection: { xs: "column", md: "row" },
            // backgroundColor: "#00000333",
            height: "100%",
            borderRadius: "10px",
            position: "absolute",
          }}
        >
          <Grid
            xs={12}
            sx={{
              ...styles.container,
              display: "flex",
              // let height shrink on mobile
              height: { xs: "auto", md: "100%" },
              top: { xs: "-1%", md: 2 },
              p: { xs: 1, md: 3 },
              // Reduce left padding on mobile
              pl: { xs: 2, md: "38px" },
              flexDirection: "column",
              gap: 2,
            }}
          >
            {/* Wrapper container to stack everything inside */}
            <Grid container direction="column" spacing={2} style={{}}>
              {/* Stats + Achievements Row */}
              <Grid
                container
                item
                spacing={2}
                sx={{
                  width: "100%",
                  ml: { xs: "-3%", md: "2px" },
                  mb: { xs: 2, md: 1 },
                  mt: { xs: "1%", md: "-3%" },
                }}
              >
                {/* Stats + Achievements Row */}
                <Grid
                  container
                  item
                  spacing={2}
                  sx={{
                    width: "100%",
                    ml: { xs: "-3%", md: "2px" },
                    mb: { xs: 2, md: 1 },
                    mt: { xs: "1%", md: "3%" },
                  }}
                >
                  <Grid
                    item
                    container
                    xs={3}
                    md={4}
                    sx={styles.sectionBox}
                    style={{ padding: 0, justifyContent: "left" }}
                  >
                    <Box style={{ height: 50, width: 50, marginRight: "10%" }}>
                      <NeoButton
                        isIcon={true}
                        icon={<MenuRounded />}
                        color={Theme.palette.tirciary.main}
                        width={100}
                        borderRadius={14}
                        onClick={() => setSettingsVisible(true)}
                      />
                    </Box>

                    {/* <Box
					  style={{
						height: "100%",
						width: 50,
						position: "relative",
					  }}
					>
					  <Avatar
						src={
						  userData?.imgUrl
							? userData.imgUrl
							: require("../../@shared/assets/icons/profile_icon.png")
						}
						style={{
						  width: 50,
						  height: 50,
						  position: "absolute",
						  left: window.innerWidth >= 900 ? 0 : -10,
						  top: "50%",
						  transform: "translateY(-50%)",
						  cursor: "pointer",
						}}
					  />

					  <Box
						sx={{
						  width: 38,
						  height: 38,
						  position: "absolute",
						  right: "-35%",
						  bottom: "-30%",
						  zIndex: 100,
						}}
					  >
						<Box
						  sx={{
							width: "100%",
							height: "100%",
							position: "relative",
						  }}
						>
						  <img
							src={getBadgeByLevel(userData.level).badge}
							alt=""
							style={{
							  width: "100%",
							  height: "100%",
							  position: "relative",
							  left: window.innerWidth >= 900 ? 0 : -42,
							}}
						  />
						  <Typography
							variant="caption"
							style={{
							  fontWeight: "bold",
							  position: "absolute",
							  top: "50%",
							  left: window.innerWidth >= 900 ? "50%" : "-62%",
							  transform: "translate(-50%, -50%)",
							  color: "#fff",
							}}
						  >
							{userData.level}
						  </Typography>
						</Box>
					  </Box>
					</Box> */}
                  </Grid>

                  <Grid
                    item
                    xs={9}
                    sm={8}
                    sx={{
                      ...styles.sectionBox,
                      justifyContent: "space-between",
                    }}
                    style={{ padding: 0 }}
                  >
                    {/* TOKENS  */}

                    <NeoMenuItem
                      icon={require("../../@shared/assets/infift_token.png")}
                      label={formatNumber(infinityTokens) || 0}
                      onClick={() => {
                        if (userData?.roles.includes("admin")) {
                          setPackOpeningVisible(true);
                        } else {
                          console.log(
                            "Open a modal showning the amount of tokens"
                          );
                          setMessage("Infinity Tokens will be available soon!");
                          setInfo(true);
                          //   setInfinityTokensVisible(true);
                        }
                      }}
                      endAdorn={
                        <Add
                          style={{
                            marginLeft: 2,
                            fontSize: 20,
                            color: "#fee399",
                          }}
                        />
                      }
                    />

                    <NeoMenuItem
                      onClick={() => {
                        setQuestsAndRewardsVisible(true);
                      }}
                      label={
                        unclaimedRewardsAndQuests > 99
                          ? "99+"
                          : unclaimedRewardsAndQuests
                      }
                      icon={require("../../@shared/assets/icons/reward_icon.png")}
                      redDot={unclaimedRewardsAndQuests > 1 ? true : false}
                    />

                    <NeoMenuItem
                      onClick={() => {
                        setMyQuestsVisible(true);
                      }}
                      label={
                        quests?.filter((quest) => !quest.completed).length > 99
                          ? "99+"
                          : quests?.filter((quest) => !quest.completed).length
                      }
                      icon={require("../../@shared/assets/icons/quest_scroll_icon.png")}
                      redDot={quests?.find(
                        (quest) =>
                          !quest.completed &&
                          getQuestProgress(quest, questLog) >= quest.goal
                      )}
                    />

                    {/* REWARDS && QUESTS * */}

                    <Box
                      sx={{
                        width: "30px",
                        height: "30px",
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        justifyContent: "flex-end",
                        position: "relative",
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        //   spriteRef.current?.start(),
                        //   setPackOpeningVisible(true);
                        console.log("LEADERBOARD");
                        setLeaderboardVisible(true);
                        // handleNavigate("Test");
                      }}
                    >
                      <img
                        alt=""
                        src={require("../../@shared/assets/icons/clans_icon.png")}
                        style={{
                          width: 35,
                          height: 35,
                          position: "absolute",
                          left: window.innerWidth >= 900 ? -10 : 10,
                        }}
                      />
                      <img
                        src={require("../../@shared/assets/icons/lock_deck_icon2.png")}
                        style={{
                          width: 22,
                          height: 22,
                          position: "absolute",
                          right: 2,
                          bottom: -3,
                        }}
                      />
                    </Box>
                    {/* LEADERBAORDS */}
                    <Box
                      sx={{
                        width: "30px",
                        height: "30px",
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        justifyContent: "flex-end",
                        position: "relative",
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        //   spriteRef.current?.start(),
                        //   setPackOpeningVisible(true);
                        console.log("LEADERBOARD");
                        setLeaderboardVisible(true);
                        // handleNavigate("Test");
                      }}
                    >
                      <img
                        alt=""
                        src={require("../../@shared/assets/icons/trophy_icon.png")}
                        style={{
                          width: 35,
                          height: 35,
                          position: "absolute",
                          left: window.innerWidth >= 900 ? -10 : 10,
                        }}
                      />
                    </Box>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        <VoidCityScene
          setStartRoomVisible={setStartRoomVisible}
          setJoinRoomVisible={setJoinRoomVisible}
          setSettingsVisible={setSettingsVisible}
          setTownQuestsVisible={setTownQuestsVisible}
          onLocalMove={throttledUpdate}
          players={players}
        />

        {isXs && (
          <WebJoystick
            size={100}
            thumbSize={50}
            onMove={handleJoyMove}
            onRelease={handleJoyRelease}
          />
        )}

        <JoinRoomModal
          visible={joinRoomVisible}
          onClose={() => setJoinRoomVisible(false)}
          userId={userData?.id}
        />
        <StartRoomModal
          visible={startRoomVisible}
          onClose={() => setStartRoomVisible(false)}
          userId={userData?.id}
        />
        <QuestsAndRewardsModal
          visible={questsAndRewardsVisible}
          onClose={() => setQuestsAndRewardsVisible(false)}
        />

        <MyQuestsModal
          visible={myQuestsVisible}
          onClose={() => setMyQuestsVisible(false)}
        />

        <TownQuestsModal
          visible={townQuestsVisible}
          onClose={() => setTownQuestsVisible(false)}
          town={"Void City"}
          availableQuests={townQuests}
        />

        {packOpeningVisible && (
          <PackOpeningModal
            visible={packOpeningVisible}
            onClose={() => setPackOpeningVisible(false)}
          />
        )}

        <LeaderBoardModal
          visible={leaderboardVisible}
          onClose={() => setLeaderboardVisible(false)}
        />
      </Container>
    </Grid>
  );
};

const styles = {
  container: {
    display: "flex",
    flex: 1,
    position: "relative",
    overflow: { xs: "none", md: "hidden" },
  },
  text: { color: "#fff", fontWeight: "bold" },
  sectionBox: {
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
    // backgroundColor: "#00000033",
  },
  sectionText: {
    color: "#fff",
    fontWeight: "bold",
    fontSize: 14,
  },
  userDataCotainer: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
  },
  menuButtonContainer: {
    width: "100%",
    mt: 2,
  },
  menuButton: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    transition: "all 0.2s ease-in-out",
    "&:hover": {
      opacity: 0.95,
    },
  },
  menuTitle: {
    color: "#fff",
    fontSize: "18px",
    fontWeight: "bold",
    textAlign: "center",
    textShadow: "1px 1px #000",
  },
  menuSubtitle: {
    color: "#fff",
    fontSize: "12px",
    fontWeight: 400,
    textAlign: "center",
    mt: "4px",
  },
};

export default PracticeWorld;
